import { useAuth } from "./AuthContext";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
    const { token, isTokenExpired } = useAuth();

    if (!token || isTokenExpired(token)) {
        return <Navigate to="/" replace />;
    }

    return children;
}
